import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, TextField } from '@mui/material';
import axios from 'axios';
import { getSettings, updateSetting } from '../api/api';
import { toast } from "react-toastify";

const DataSetting = () => {
  const [allSettings, setAllSettings] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedSetting, setSelectedSetting] = useState({ key: '', value: '' ,id:''});
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {

    fetchSettings();

  }, []);


  const fetchSettings = async () => {
    getSettings().then((response) => {
        setAllSettings(response.value);
    });
  }
  const handleOpen = (user = { key: '', value: '',id:'' }, update = false) => {
console.log(user,"handleOpen");
    setSelectedSetting(user);
    setIsUpdate(update);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedSetting({ key: '', value: '',id:'' });
  };

  const handleSave = () => {
    const formData = new FormData();
    if (!isUpdate) {
     
         formData.append('Key', selectedSetting.key); // Buraya gerekli değerleri ekleyin
         formData.append('Value', selectedSetting.value); // Buraya gerekli değerleri ekleyin
         formData.append('KMLData', selectedSetting.KMLData,  selectedSetting.KMLData.name); // Dosya ve adı ekleniyor         formData.append('Id', selectedSetting.id); // Buraya gerekli değerleri ekleyin
         

        updateSetting(formData).then(() =>{
            
            toast.success(" Eklendi.");
            fetchSettings();
            handleClose();
        });
    } else {
      formData.append('Key', selectedSetting.key); // Buraya gerekli değerleri ekleyin
      formData.append('Value', selectedSetting.value); // Buraya gerekli değerleri ekleyin
      formData.append('KMLData', selectedSetting.KMLData, selectedSetting.KMLData.name); // Dosya ve adı ekleniyor
      formData.append('Id', selectedSetting.id); // Buraya gerekli değerleri ekleyin
      

        updateSetting(formData).then((response) =>{
          if(response.isSuccess)
          {
              toast.success("başarıyla güncellendi.*");
              fetchSettings();
              handleClose();
          }
          else{
            toast.error(response.error?.errors[0]);
          }
          
        });
  
    }
  };

  const columns = [
    { field: 'id', headerName: 'ID', width: 90, visible: false},
    { field: 'key', headerName: 'Anahtar', width: 250 },
    { field: 'value', headerName: 'Değer', width: 300 },
    {
      field: 'actions',
      headerName: '',
      width: 250,
      renderCell: (params) => (
        <Button variant="contained" color="primary" onClick={() => handleOpen(params.row, true)}>
          Güncelle
        </Button>
      ),
    },
  ];

  const [file, setFile] = useState(null); // Dosya state'i

  // Dosya seçildiğinde binary data elde etme
//   const handleFileChange = (e) => {
//     console.log(e,"handle")
//     const selectedFile = e.target.files[0];
//     const reader = new FileReader();
    
//     reader.onloadend = () => {
//       setSelectedSetting({ ...selectedSetting, KMLData: reader.result }); // binary datayı value'ya set et
//       console.log(reader.result,'File changed');
//     };
    
//     if (selectedFile) {
//       reader.readAsArrayBuffer(selectedFile);
//     }
//   };

  function onFileChange(e) {

    const selectedFile = e.target.files[0];
    console.log(selectedFile,"onFileChange");
    if (selectedFile && (selectedFile.name.indexOf(".kml") !== -1 || selectedFile.name.indexOf(".pdf") !== -1)) {
      setSelectedSetting({ ...selectedSetting, KMLData:selectedFile });
    } else {
      toast.error('Lütfen KML anahtarı için KML, BasvuruFormu anahtarı için pdf dosyası seçin.');
    }

   // let files = e.target.files;
   
    // let fileReader = new FileReader();
    // fileReader.readAsDataURL(files[0]);
  
    // fileReader.onload = (event) => {
    //    // setPhoto(event.target.result);
    //    setSelectedSetting({ ...selectedSetting, KMLData:event.target.result  }); // binary datayı value'ya set et
    // }
  }




  // Checkbox değişimi
  const handleCheckboxChange = (e) => {
    setSelectedSetting({ ...selectedSetting, value: e.target.checked });
  };

  return (
    <div>
      {/* <Button variant="contained" color="primary" onClick={() => handleOpen()}>
        Yeni anahtar Ekle
      </Button> */}
      <div style={{ height: 700, width: '100%', marginTop: 20 }}>
        <DataGrid   
    columnVisibilityModel={{
        // Hide columns status and traderName, the other columns will remain visible
        id: false,        
      }}
   rows={allSettings} columns={columns} pageSize={25} />
      </div>
      <Dialog maxWidth={'md'} fullWidth={true} open={open} onClose={handleClose}>
      <DialogTitle>{isUpdate ? 'Güncelle' : 'Ekle'}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Anahtar"
          fullWidth
          variant="outlined"
          value={selectedSetting.key}
        //   onChange={(e) => setSelectedSetting({ ...selectedSetting, key: e.target.value })}
        />

        {selectedSetting.key === 'SubeKontrol' ? (
          <>
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedSetting.value=='false' ? false:true}
                onChange={handleCheckboxChange}
              />
              
            }
            label="Durum"
          />
        
          </>
        ) : selectedSetting.key === 'KML' || selectedSetting.key=='BasvuruFormu' ? (
          <input type="file" onChange={onFileChange} />
        ) : (
          <TextField
            margin="dense"
            label="Değer"
            fullWidth
            variant="outlined"
            value={selectedSetting.value}
            onChange={(e) => setSelectedSetting({ ...selectedSetting, value: e.target.value })}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          İptal
        </Button>
        <Button onClick={handleSave} color="primary">
          Kaydet
        </Button>
      </DialogActions>
    </Dialog>
    </div>
  );
};

export default DataSetting;
